import React, { useEffect, useState } from "react";
// import { makeStyles } from '@mui/styles';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import { Button } from "evergreen-ui";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import Details from "../Tasks/Details";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import AssingUser from "../Tasks/AssignUser";
import ShowFile from "../Tasks/ShowFile";
import PersonIcon from "@mui/icons-material/Person";
import Comments from "../Tasks/Comments";
import AttachFile from "../Tasks/AttachFile";
import Status from "../Tasks/Status";
import moment from "moment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CommentIcon from "@mui/icons-material/Comment";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import feHost from "../../assets/js/feHost";
import Lottie from "lottie-react-web";
import APP_CONSTANTS from "../../assets/js/constants";
import WorkLogs from "../Tasks/WorkLog";
import helpers from "../../assets/js/helper";
import ViewAllUnits from "./ViewAllUnits";
// import Rating from '@mui/material/R';
import * as AiIcons from "react-icons/ai";
import Tooltip from "@mui/material/Tooltip";
import Preloading from "../Preload/Preloading";
import AssignUser from "../Tasks/AssignUser";
import GroupIcon from "@mui/icons-material/Group";
import { IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditCustomer from "./EditCustomer";
import { Box } from "@mui/system";
import { subDays, addDays } from "date-fns";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CInstallationFromCCDialog from "../Tasks/TasksTable/Components/CInstallationFromCCDialog";
import CreateCustomer from "../Tasks/TasksTable/Components/CreateCustomer";
import CCustomerCareDialog from "../Tasks/TasksTable/Components/CCustomerCareDialog";
import UCustomerCareDialog from "../Tasks/TasksTable/Components/UCustomerCareDialog";
import CreateMissionDialog from "../Planning/Components/CreateMissionDialog";
import host from "../../assets/js/Host";
import ShowMissions from "./ShowMissions";
import axios from "../../assets/js/AxiosInterceptors";

const cookies = new Cookies();
var spin;

export default function ControlledExpansionPanels(props) {
  // const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");
  const [isShown, setIsShown] = React.useState(false);
  const [showAssing, setShowAssing] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showAttachFile, setShowAttachFile] = useState(false);
  const [allMissionsForTask,setAllMissionsForTask]=useState([])
  const [showPromot, setShowPromot] = React.useState(false);

  //this states for make installation task
  const [open, setOpen] = useState(false);
  const [selectedInstallationFields, setSelectedInstallationFields] = useState(
    null
  );
  const [governoratesSelected, setGovernoratesSelected] = useState([]);
  const [governorates, setgovernorates] = useState([]);
  const [workTypesSelected, setWorkTypesSelected] = useState([]);
  const [workTypes, setworkTypes] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [
    openCreateInstallationDialog,
    setOpenCreateInstallationDialog,
  ] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [addDaysToFixDateOffset, setAddDaysToFixDateOffset] = useState(0);
  const [openCCustomerDialog, setOpenCCustomerDialog] = useState(false);
  const [editCustomer, setEditCustomer] = useState(null);
  const [openTelegramDialog, setOpenTelegramDialog] = useState(false);
  const [sendTaskTelegram, setSendTaskTelegram] = useState({});
  const [editTaskId, setEditTaskId] = useState(false);
  const [selectReqestTypes, setSelectReqestTypes] = useState([]);
  const [requestTypes, setRequestTypes] = useState([]);
  const [selectedCustomerCareFields, setSelectedCustomerCareFields] = useState(
    null
  );
  const [customers, setcustomers] = useState([]);
  const [customerID, setcustomerID] = useState(null);
  const [taskTypesSelected, setTaskTypesSelected] = useState([]);
  const [inUpdateProcess, setInUpdateProcess] = useState(false);
  const [selectedDateRange, SetSelectedDateRange] = useState([
    {
      startDate: moment
        .utc(subDays(new Date(), 1))
        .startOf("day")
        .toDate(),
      endDate: moment
        .utc(subDays(new Date(), 1))
        .endOf("day")
        .toDate(),
      key: "selection",
    },
  ]);
  const [users, setUsers] = useState([]);
  // function to get the date range changed value
  function dateChange(item) {
    setAddDaysToFixDateOffset(1);
    if (item && item?.selection) SetSelectedDateRange([item.selection]);
    else if (item && item?.range1) SetSelectedDateRange([item.range1]);
  }
  const [usersCreatedbySelected, setUsersCreatedbySelected] = useState([]);
  const [usersAssignedToSelected, setUsersAssignedToSelected] = useState([]);
  const [editTaskData, seteditTaskData] = useState({
    monitorSelected: [],
    assignedUsersSelected: [],
    governoratesSelected: [],
    geoFenceSelected: [],
    workTypesSelected: [],
    weightSelected: "0",
    deadlineDateSelected: new Date(),
    description: "",
    geofenceName: "",
    governorateSelected: [],
    numberOfUnits: "0",
    contactedNumber: "0",
    contactedPerson: "",
    customerId: null,
    selectedStatusKeys: [],
  });
  const [taskStatuses, setTaskStatuses] = useState([
    {
      status_name: "",
      status_id: 0,
    },
  ]);
  const [taskStatusesSelected, setTaskStatusesSelected] = useState([]);
  const [taskTypes, setTaskTypes] = useState([
    {
      name: "",
      task_type_id: 0,
    },
  ]);
  const [assigners, setAssigners] = useState([
    {
      name: "",
      user_id: 0,
    },
  ]);
  const [monitors, setMonitors] = useState([
    {
      name: "",
      user_id: 0,
    },
  ]);
  // variable to hold external users
  const [externalUsers, setExternalUsers] = useState([
    {
      name: "",
      user_id: 0,
    },
  ]);
  // variable to hold internal users
  const [internalUsers, setInternalUsers] = useState([
    {
      name: "",
      user_id: 0,
    },
  ]);
  const [subTaskData, setSubTaskData] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [showAllMissions,setShowAllMissions]=useState(false);
  //create mission states ....
  const [openCreatMission, setOpenCreateMission] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [editTaskDataMission, setEditTaskDataMission] = useState({});
  const [availableResources, setAvailableResources] = useState([]);
  const [executionTime, setExecutionTime] = useState(
    moment().day() == 4 ? moment().add(2, "days") : moment().add(1, "days")
  );
  const [firstOpen, setFirstOpen] = useState(false);
  const [missionData, setMissionData] = useState({
    missionTypeSelectedItemKeys: [],
    executionTime: new Date(),
    durationHours: 0,
    durationMinutes: 15,
    instructionValue: "",
    task_id: 0,
  });
  const updateTable = () => {};
  const [missionTypes, setMissionTypes] = useState([
    {
      name: "",
      id: 0,
    },
  ]);
  const [vehicles, setVehicles] = useState([]);

  const getEditTaskDataFromAPI = async (selectedTaskId, createInstallation) => {
    const cookies = new Cookies();
    const headers = { jwt: cookies.get("token") };

    let hostPath =
      Host +
      (props?.externalTasks == 1
        ? `tasks/external_customer_care/${selectedTaskId}`
        : `tasks/customer_care/${selectedTaskId}`);

    setOpen(true);
    let res = await axios({
      url: hostPath,
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        //console.log("inside get data")
        if (response.data.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          //console.log(response.data.data ? response.data.data[0] : {})

          try {
            var selectedListValues = {
              monitorSelected: response.data.data[0]?.monitors_ids
                ? response.data.data[0]?.monitors_ids
                    .split(",")
                    .map((id) => parseInt(id, 10))
                : [0],
              assignedUsersSelected: response.data.data[0]?.to_ids
                ? response.data.data[0]?.to_ids
                    .split(",")
                    .map((id) => parseInt(id, 10))
                : [],
            };

            seteditTaskData({
              task_id: selectedTaskId,
              monitorSelected: response.data.data[0]?.monitors_ids
                ? response.data.data[0]?.monitors_ids
                    .split(",")
                    .map((id) => parseInt(id, 10))
                : [0],
              assignedUsersSelected: response.data.data[0]?.to_ids
                ? response.data.data[0]?.to_ids
                    .split(",")
                    .map((id) => parseInt(id, 10))
                : [],
              workTypesSelected: [],
              weightSelected: response.data.data[0]?.weight
                ? response.data.data[0]?.weight
                : 0,
              deadlineDateSelected: response.data.data[0]?.dead_time,
              description: response.data.data[0]?.description,
              taskId: selectedTaskId,
              numberOfUnits: response.data.data[0]?.num_of_units
                ? response.data.data[0]?.num_of_units
                : 0,
              contactedNumber: response.data.data[0]?.contacted_num,
              contactedPerson: response.data.data[0]?.contacted_person,
              customerId: response.data.data[0]?.customer_id,
              status: response.data.data[0]?.status,
              governorateSelected: response.data.data[0]?.governorate_id
                ? response.data.data[0]?.governorate_id
                : [],
              geofenceName: response.data.data[0]?.Geofence
                ? response.data.data[0]?.Geofence
                : "",
              geoFenceSelected: [],
            });
            setcustomerID(response.data.data[0]?.customer_id);
            setInUpdateProcess(true);

            localStorage.setItem(
              "editTaskData",
              JSON.stringify({
                task_id: selectedTaskId,
                monitorSelected: response.data.data[0]?.monitors_ids
                  ? response.data.data[0]?.monitors_ids
                      .split(",")
                      .map((id) => parseInt(id, 10))
                  : [0],
                assignedUsersSelected: response.data.data[0]?.to_ids
                  ? response.data.data[0]?.to_ids
                      .split(",")
                      .map((id) => parseInt(id, 10))
                  : [],
                workTypesSelected: [],
                weightSelected: response.data.data[0]?.weight
                  ? response.data.data[0]?.weight
                  : 0,
                deadlineDateSelected: response.data.data[0]?.dead_time,
                description: response.data.data[0]?.description,
                taskId: selectedTaskId,
                numberOfUnits: response.data.data[0]?.num_of_units
                  ? response.data.data[0]?.num_of_units
                  : 0,
                contactedNumber: response.data.data[0]?.contacted_num,
                contactedPerson: response.data.data[0]?.contacted_person,
                customerId: response.data.data[0]?.customer_id,
                status: response.data.data[0]?.status,
                governorateSelected: response.data.data[0]?.governorate_id
                  ? response.data.data[0]?.governorate_id
                  : null,
                geofenceName: response.data.data[0]?.Geofence
                  ? response.data.data[0]?.Geofence
                  : "",
                geoFenceSelected: [],
              })
            );

            setOpen(false);
            setEditTaskId(selectedTaskId);
            if (createInstallation) {
              setOpenCreateInstallationDialog(true);
            } else {
              setOpenEditDialog(true);
            }
          } catch (error) {
            toast.error("error:" + error);
          }
        }
      })
      .catch((err) => {});
  };
  var headers = {
    jwt: cookies.get("token"),
  };
  async function populateDropDownLists() {
    /// fetch task statuses from the api
    try {
      setLoadingData(true);
      const statusesResult = await axios({
        url: Host + `tasks/statuses`,
        method: "GET",
        headers: headers,
      });
      setTaskStatuses(statusesResult.data.data);
      //console.log(res.data.data);
      //console.log("taskstatuses")
      if (
        statusesResult.data.data.filter(function(e) {
          return e.status_id === APP_CONSTANTS.newType_id.status_id;
        }).length > 0 &&
        statusesResult.data.data.filter(function(e) {
          return e.status_id === APP_CONSTANTS.inprogressType_id.status_id;
        }).length > 0
      ) {
        setTaskStatusesSelected([
          APP_CONSTANTS.newType_id,
          APP_CONSTANTS.inprogressType_id,
        ]);
        //console.log("insid ==")
      }
      const usersResult = await axios({
        url: Host + `users/userslist`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1,
        }
      });
      setUsers(usersResult.data.data);
      const monitors = usersResult.data.data.filter(
        (user) => user.department_id != APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID
      );
      setMonitors(monitors);
      const assigners = usersResult.data.data.filter(
        (user) => user.department_id != APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID
      );
      setAssigners(assigners);

      /// fetch task types from the api
      const taskTypesResult = await axios({
        url: Host + `task_types`,
        method: "GET",
        headers: headers,
      });
      setTaskTypes(taskTypesResult.data.data);
      /// fetch Internal techs users from the api
      const internalUsersResult = await axios({
        url:
          Host +
          `users/userslist?department_id=${APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID}`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1,
        }
      });
      setInternalUsers(internalUsersResult.data.data);

      /// fetch External techs users from the api
      const externalUsersResult = await axios({
        url:
          Host +
          `users/userslist?department_id=${APP_CONSTANTS.ENGINEERS_DEPARTMENT_ID}`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1,
        }
      });
      setExternalUsers(externalUsersResult.data.data);

      /// installation task related data
      /// fetch governorates from the api
      const governoratesResult = await axios({
        url: Host + `governorates`,
        method: "GET",
        headers: headers,
      });
      //console.log("from api governorates");
      //console.log(governoratesResult.data.data);
      setgovernorates(governoratesResult.data.data);

      /// fetch governorates from the api
      const workTypes = await axios({
        url: Host + `work_types`,
        method: "GET",
        headers: headers,
      });
      console.log(workTypes.data.data);
      setworkTypes(workTypes.data.data);

      axios({
        url: Host + `planning/mission_types`,
        method: "GET",
        headers: headers,
      })
        .then((res) => {
          setMissionTypes(res.data.data.data);
        })
        .catch((err) => {});
      axios({
        url: Host + `car_inspection/cars/list`,
        method: "GET",
        headers: headers,
      })
        .then((res) => {
          setVehicles(res?.data?.data?.data);
        })
        .catch((err) => {});
      setLoadingData(false);
    } catch (error) {
      toast.error("Error: " + error);
      setLoadingData(false);
    }
  }
  const getSubTaskData = async (id) => {
    axios({
      url: Host + `tasks/task/${id}?params={"from_date":0,"to_date":0}`,
      method: "GET",
      headers: headers,
    }).then((res) => {
      console.log("this is noti data", res.data.data);
      setSubTaskData(res.data.data[0]);
    });
  };
  useEffect(() => {
    populateDropDownLists();
  }, []);

  useEffect(() => {
    if (props?.SubTaskId) {
      getSubTaskData(props?.SubTaskId);
    }
  }, [props?.SubTaskId]);

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "#188718b5";
      case "rejected":
        return "#da251e";
      case "closed":
        return "gray";
      case "new":
        return "#2e6b95";
      case "in progress":
        return "#f06105cc";
      case "assigned":
        return "#d5ad00d4";
      case "archived":
        return "black";
      default:
        return "lightgrey";
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : true);
  };

  function Delete(data) {
    spin = true;
    var headers = {
      "Content-Type": "application/json",
      jwt: cookies.get("token"),
    };

    axios({
      url: Host + `tasks/task/${data}`,
      method: "DELETE",
      headers: headers,
    })
      .then((response) => {
        if (response.data.status === false) {
          toast.error(response.data.data.text);
          spin = false;
        } else if (response.data.status === true) {
          const { onRefTask } = props;
          onRefTask();
          toast.success("deleted successfully");
          spin = false;
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        spin = false;
      });
  }

  const getExtraDescription = () => {
    var extraDescription = "";
    if (props.task_type_id == APP_CONSTANTS.INSTALLATION_TYPE) {
      extraDescription = "عدد الوحدات : " + props.num_of_units + "\n";
      extraDescription += "المحافظة : " + props.governorate_name + "\n";
      extraDescription += "نوع العمل : " + props.work_type_name + "\n";
      extraDescription += "اسم المخول : " + props.contacted_person + "\n";
      extraDescription += "رقم المخول : " + props.contacted_num + "\n";
      extraDescription += "رقم الزبون : " + props.customer?.phone + "\n";
    } else if (props.task_type_id == APP_CONSTANTS.CUSTOMER_CARE_TYPE) {
      extraDescription = "اسم المخول : " + props.contacted_person + "\n";
      extraDescription += "رقم المخول : " + props.contacted_num + "\n";
      extraDescription += "رقم الزبون : " + props.customer?.phone + "\n";
    }

    return extraDescription;
  };

  const closeShowAllUnits = () => {
    setIsShown(false);
  };

  React.useEffect(() => {
    console.log("sadasdasdasdas", props?.task_type_id);
  }, [props.task_type_id]);

  const renderRatingValue = () => {
    let arr = [];
    if (props?.rate_score) {
      for (let i = 1; i <= 5; i++) {
        if (i <= props?.rate_score) {
          arr.push(
            <AiIcons.AiFillStar
              style={{ color: "#ffbc03", fontSize: "25px" }}
            />
          );
        } else {
          arr.push(
            <AiIcons.AiFillStar
              style={{ color: "lightgrey", fontSize: "25px" }}
            />
          );
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        arr.push(
          <AiIcons.AiFillStar
            style={{ color: "lightgrey", fontSize: "25px" }}
          />
        );
      }
    }
    return arr;
  };

  const handleGetDate = (date) => {
    if (date !== "0000-00-00") {
      return helpers.formatDate(date);
    } else return false;
  };

  const handleGetTime = (time, date) => {
    if (time !== "00:00:00" && date !== "0000-00-00") {
      return time;
    } else return false;
  };
  function openAssociatedTask(id, subId, isExternal) {
    let value = "";
    if (id && subId && isExternal)
      value =
        feHost +
        `Detials_TaskEdit?id=${id}&subId=${subId}&external=${isExternal}`;
    else if (id && subId)
      value = feHost + `Detials_TaskEdit?id=${id}&subId=${subId}`;
    else if (id) value = feHost + `Detials_TaskEdit?id=${id}`;
    window.open(value, "_blank");
  }

  useEffect(() => {
    console.log("sdasdasdvv", props?.users);
    return () => {};
  }, [props?.users]);

  const getEditTaskDataFromForMissionAPI = async (selectedTaskId) => {
    const cookies = new Cookies();
    const headers = { jwt: cookies.get("token") };
    setOpen(true);
    let res = await axios({
      url: Host + `tasks/task/${selectedTaskId}`,
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        //console.log("inside get data")
        if (response.data.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          /// fetch task statuses from the api
          const searchFieldsValues = JSON.parse(
            localStorage.getItem("searchFiltersCreateMission")
          );
          axios({
            url:
              Host +
              `planning/unavailable_employees?params={"working_day":"${executionTime}"}`,
            method: "GET",
            headers: headers,
          }).then((res) => {
            const currentAvailableResources = res.data.data.data
              ? res.data.data.data.filter(function(e) {
                  return !e.unAvailable;
                })
              : [];

            setAvailableResources(currentAvailableResources);

            const data = response.data.data ? response.data.data[0] : {};

            setMissionData({
              missionTypeSelectedItemKeys: [],
              executionTime: new Date(),
              durationHours: 0,
              durationMinutes: 15,
              instructionValue: "",
              task_id: 0,
            });

            setEditTaskDataMission({
              taskType: data ? data.task_type : "",
              monitor: data && data.monitor ? data.monitor.name : "",
              weightSelected: data ? data.weight : 0,
              deadlineDate:
                data.dead_time === "1970-01-01T00:00:00.000Z"
                  ? ""
                  : data.dead_time,
              description: data ? data.description : "",
              title: data ? data.task_title : "",
              customer:
                data && data.customer
                  ? data.customer
                  : { id: 0, name: "", phone: "" },
              numberOfUnits: data ? data.num_of_units : 0,
              contactedNumber: data ? data.contacted_num : 0,
              contactedPerson: data ? data.contacted_person : "",
              missionTypes: missionTypes ? missionTypes : [],
              instructions: data ? data.description : "",
              availableTechniciansResources: currentAvailableResources
                ? currentAvailableResources
                    .filter(
                      (item) =>
                        item.department_id ==
                        APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID
                    )
                    .map((item) => {
                      return {
                        ID: item.user_id,
                        name: item.name,
                        teamLeader: 0,
                        executor: 0,
                      };
                    })
                : [],
              availableEngineersResources: currentAvailableResources
                ? currentAvailableResources
                    .filter(
                      (item) =>
                        item.department_id ==
                        APP_CONSTANTS.ENGINEERS_DEPARTMENT_ID
                    )
                    .map((item) => {
                      return {
                        ID: item.user_id,
                        name: item.name,
                        teamLeader: 0,
                        executor: 0,
                      };
                    })
                : [],
            });

            // const clearedMissionTypes=missionTypes.map((missionType)=>{
            //     return {
            //         id: missionType.id,
            //         name: missionType.name
            //     }
            // })
            console.log("missionTypes");
            console.log(missionTypes);
            console.log("clearedMissionTypes");
            // console.log(clearedMissionTypes);
            // setMissionTypes(clearedMissionTypes)
            setEditTaskId(selectedTaskId);
            setFirstOpen(true);
            setOpen(false);
            setOpenCreateMission(true);
          });
        }
      })
      .catch((err) => {});
  };

  const getMissionsforTask=async()=>{
    if(!props?.id){
      console.log('task id not found!');
      return;
    }
    let data=null
    let headers={
      'jwt':cookies.get('token'),
      "Content-Type": "application/json",
    }
    try{
      data=await axios({
         url:host+"missions/get_missions_by_task_id/"+props?.id,
         method:"get",
         headers:headers
      })
      if(data&&data?.status&&data?.data?.status){
        setAllMissionsForTask(data?.data?.data.data)
      }
    }catch(err){

    }
  }
  
  useEffect(()=>{
    getMissionsforTask()
  },[props?.id])



  return (
    <div className="ControlledExpansionPanels">
      {showPromot ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            zIndex: 44444,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 0 7px -2px rgba(0,0,0,0.2)",
              width: "600px",
              height: "300px",
              borderRadius: "5px",
              padding: "20px 20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              animationName: "popupAnimationinViewTaskDetails",
              animationDuration: "0.5s",
              animationTimingFunction: " ease-in-out",
              animationFillMode: "both",
            }}
          >
            <p style={{ fontSize: "18px" }}>
              This Task Is Associated with an External Task With status "
              {subTaskData?.status}". Do you want to open it?
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  width: "100px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  backgroundColor: "#e7bb2c",
                  border: "none",
                  outline: "none",
                  borderRadius: "5px",
                  boxShadow: "0 0 -7px 2px rgba(0,0,0,0.4)",
                  color: "#fff",
                  marginRight: "10px",
                }}
                onClick={() => {
                  setShowPromot(false);
                }}
              >
                close
              </button>
              <button
                style={{
                  width: "100px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  backgroundColor: "#0e3750",
                  border: "none",
                  outline: "none",
                  borderRadius: "5px",
                  boxShadow: "0 0 -7px 2px rgba(0,0,0,0.4)",
                  color: "#fff",
                }}
                onClick={() => {
                  openAssociatedTask(
                    props?.SubTaskId,
                    props?.TaskId,
                    props?.externalTasks
                  );
                }}
              >
                open
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {showAllMissions?<ShowMissions
        isShown={showAllMissions}
        closeShowAllUnits={()=>setShowAllMissions(false)}
        missions={allMissionsForTask}
        user_name={props?.user_name}
        account_name={props?.account_name}
        created_at={props?.created_at}
        id={props?.id}
        request_type_name={props?.request_type_name}
      />:null}
      {isShown?<ViewAllUnits
        isShown={isShown}
        closeShowAllUnits={closeShowAllUnits}
        units={props?.units}
        user_name={props?.user_name}
        account_name={props?.account_name}
        created_at={props?.created_at}
        request_type_name={props?.request_type_name}
      />:null}
      {!loadingData ? (
        <>
          {openCreateInstallationDialog?<CInstallationFromCCDialog
            data={editTaskData}
            setData={seteditTaskData}
            customerID={customerID}
            taskStatuses={taskStatuses}
            setcustomerID={setcustomerID}
            governorates={governorates}
            setgovernorates={setgovernorates}
            workTypes={workTypes}
            setworkTypes={setworkTypes}
            setOpen={setOpen}
            externalTasks={props?.externalTasks}
            open={open}
            taskTypes={taskTypes}
            editTaskId={editTaskId}
            assignedUsers={assigners}
            setAssigners={setAssigners}
            monitors={monitors}
            setMonitors={setMonitors}
            headers={headers}
            popupVisible={openCCustomerDialog}
            setpopupVisible={setOpenCCustomerDialog}
            openDialog={openCreateInstallationDialog}
            setOpenDialog={setOpenCreateInstallationDialog}
            reload={() => {}}
          />:null}

          {openCCustomerDialog ? (
            <CreateCustomer
              popupVisible={openCCustomerDialog}
              setpopupVisible={setOpenCCustomerDialog}
              openDialog={openCreateDialog}
              setOpen={setOpen}
              inUpdateProcess={inUpdateProcess}
              setOpenEditDialog={setOpenEditDialog}
              setcustomerID={setcustomerID}
              open={open}
              data={editTaskData}
              setData={seteditTaskData}
              editCustomer={editCustomer}
              setOpenDialog={setOpenCreateDialog}
            />
          ) : null}
          {openCreateDialog?<CCustomerCareDialog
            selectedCustomerCareFields={selectedCustomerCareFields}
            customerID={customerID}
            setcustomerID={setcustomerID}
            setOpen={setOpen}
            open={open}
            setEditCustomer={setEditCustomer}
            monitors={monitors}
            setMonitors={setMonitors}
            assigners={assigners}
            setAssigners={setAssigners}
            headers={headers}
            customers={customers}
            popupVisible={openCCustomerDialog}
            setpopupVisible={setOpenCCustomerDialog}
            openDialog={openCreateDialog}
            setOpenDialog={setOpenCreateDialog}
            reload={() => {}}
          />:null}
          {openEditDialog?<UCustomerCareDialog
            data={editTaskData}
            setData={seteditTaskData}
            customerID={customerID}
            taskStatuses={taskStatuses}
            setcustomerID={setcustomerID}
            setOpen={setOpen}
            open={open}
            taskTypes={taskTypes}
            editTaskId={editTaskId}
            monitors={monitors}
            setMonitors={setMonitors}
            assigners={assigners}
            setAssigners={setAssigners}
            headers={headers}
            customers={customers}
            popupVisible={openCCustomerDialog}
            setpopupVisible={setOpenCCustomerDialog}
            openDialog={openEditDialog}
            setOpenDialog={setOpenEditDialog}
            reload={() => {}}
          />:null}
          {editTaskId ? (
            <CreateMissionDialog
              data={editTaskDataMission}
              setFirstOpen={setFirstOpen}
              firstOpen={firstOpen}
              setData={setEditTaskDataMission}
              setOpen={setOpen}
              setExecutionTime={setExecutionTime}
              executionTime={executionTime}
              setAvailableResources={setAvailableResources}
              availableResources={availableResources}
              open={open}
              missionData={missionData}
              setMissionData={setMissionData}
              updateTable={updateTable}
              missionTypes={missionTypes}
              setMissionTypes={setMissionTypes}
              editTaskId={editTaskId}
              monitors={users}
              openDialog={openCreatMission}
              setOpenDialog={setOpenCreateMission}
              vehicles={vehicles}
            />
          ) : null}
        </>
      ) : null}

      {[
        APP_CONSTANTS.INSTALLATION_TYPE,
        APP_CONSTANTS.CUSTOMER_CARE_TYPE,
      ].includes(props.task_type_id) ? (
        <></>
      ) : (
        <>
          {showAssing?<AssingUser
            addForm={showAssing}
            setAddForm={setShowAssing}
            users={props?.users}
            id={props.id}
            onRefTask={props}
            assigned={props.assigned}
          />:null}
          {props.status !== "new" && props.task_type === "حذف" ? null : (
            showEdit?<EditCustomer
              addForm={showEdit}
              setAddForm={setShowEdit}
              allstatus={props.allstatus}
              onProfileDelete={props}
              id={props.id}
              title={props?.name}
              time={props.time}
              desc={props.desc}
              status={props.status}
              type={props.type}
              task_type={props.task_type}
              users={props.users}
              Geofences={props.Geofences}
              geofences={props.geofences}
              weight={props.weight}
              onRefreshGeo={props}
              monitor={props.monitor}
              onRefTask={props}
              customer={props.customer}
              Allcustomer={props.Allcustomer}
            />:null
          )}
        </>
      )}
      {showAttachFile?<AttachFile
        addForm={showAttachFile}
        setAddForm={setShowAttachFile}
        id={props.id}
        onRefTask={props}
      />:null}

      <div>
        {props.status === "approved" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "#188718b5", minWidth: 200 }}
            >
              Approved{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div> */}
          </div>
        ) : null}
        {props.status === "rejected" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "#da251e", minWidth: 200 }}
            >
              Rejected
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div> */}
          </div>
        ) : null}
        {props.status === "closed" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "gray", minWidth: 200 }}
            >
              Closed - {props.close_status_name}{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div>  */}
          </div>
        ) : null}
        {props.status === "new" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "#2e6b95", minWidth: 200 }}
            >
              New{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div> */}
          </div>
        ) : null}
        {props.status === "in progress" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "#f06105cc", minWidth: 200 }}
            >
              {" "}
              In progress{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div>  */}
          </div>
        ) : null}
        {props.status === "assigned" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "#d5ad00d4", minWidth: 200 }}
            >
              {" "}
              Assigned{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div> */}
          </div>
        ) : null}
        {props.status === "archived" ? (
          <div id="head_task" style={{ height: 35, fontSize: "16.5px" }}>
            <div
              id="tit_task"
              style={{ backgroundColor: "black", minWidth: 200 }}
            >
              {" "}
              Archived{" "}
            </div>
            <div className="weight"> {props.weight} </div>
            <div className="task_type_style"> {props.task_type} </div>
            {/* <div className='task_priority'  > {props.priority}  </div> */}
          </div>
        ) : null}
        <Box
          sx={{
            "& .MuiPaper-root::before": {
              opacity: "0 !important",
            },
            "& .MuiPaper-root": {
              boxShadow: "grey 1px 5px 4px 0px !important",
              backgroundColor: "#fff !important",
              overflow: "hidden",
            },
          }}
        >
          <Accordion
            square
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            style={{
              backgroundColor: "rgba(241, 237, 237, 0.42)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              boxShadow: "1px 1px 4px 0px grey",
              margin: "0px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    color: "#2e6b95",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {props?.customer?.name
                    ? helpers.formatCustomerName(props?.customer?.name)
                    : props?.name}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      color: "rgb(127, 127, 127)",
                      fontSize: 14,
                      fontWeight: "100",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <PersonIcon style={{ fontSize: 14, marginRight: 4 }} />{" "}
                      {props.createdby}
                      {props?.monitor?.name !== null ? (
                        <div style={{ marginLeft: 16 }}>
                          {" "}
                          <img
                            src={require("../../assets/img/2.png")}
                            alt="img"
                            style={{ height: 15 }}
                          />{" "}
                          {props?.monitor?.name}{" "}
                        </div>
                      ) : null}
                    </div>
                    <div style={{ width: "19%" }}>
                      {" "}
                      {props.time === "1970-01-01T00:00:00.000Z" ? null : (
                        <div id="parent">
                          {moment().format("X") >=
                          moment(props.time).format("X") ? (
                            <AccessAlarmIcon
                              style={{ color: "#da251e", cursor: "pointer" }}
                            />
                          ) : (
                            <AccessAlarmIcon
                              style={{ color: "green", cursor: "pointer" }}
                            />
                          )}

                          <div id="hover-content">
                            {moment(props.time).format("lll")}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    color: "rgb(127, 127, 127)",
                    fontSize: 14,
                    fontWeight: "100",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <PeopleAltIcon style={{ fontSize: 14, marginRight: 4 }} />
                  {props.assigners.length > 0 ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {" "}
                      {props.assigners[0].name}{" "}
                      {props.assigners.length > 1 ? (
                        <span id="OthersParent">
                          {" "}
                          + {props.assigners.length - 1} Others{" "}
                          <span id="OthersContent">
                            {" "}
                            {props.assigners.map((p, i) => (
                              <div key={i}> {p.name} </div>
                            ))}{" "}
                          </span>{" "}
                        </span>
                      ) : null}
                    </div>
                  ) : (
                    <span>No Body</span>
                  )}
                </div>

                <div
                  style={{
                    color: "rgb(127, 127, 127)",
                    fontSize: 10,
                    fontWeight: "100",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingRight: "3px",
                  }}
                >
                  <div>
                    {moment(props.created_at).format("lll")}
                    <div> # {props.id} </div>
                  </div>
                  <div>
                    <div id="icons_headerTask">
                      {props.files.length > 0 ? (
                        <AttachFileIcon className="icon_file_head" />
                      ) : null}
                      {props.geofences.geo_name !== "null" &&
                      props.geofences.geo_name !== null ? (
                        <LocationOnIcon style={{ fontSize: 18 }} />
                      ) : null}
                      {props.comments_count > 0 ? (
                        <div>
                          {" "}
                          {props.comments_count}{" "}
                          <CommentIcon
                            style={{ fontSize: 18, color: "#3e83b2" }}
                          />{" "}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                display: "flex",
                flexDirection: "column",
                borderTop: "1px solid rgb(225, 227, 229)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "30px",
                }}
              >
                <div>
                  {" "}
                  {props.files.length > 0 ? (
                    <ShowFile files={props.files} onRefTask={props} />
                  ) : null}
                </div>

                <div>
                  <button
                    className="btn_lang"
                    onClick={() => {
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: start;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    {" "}
                    <FormatAlignLeftIcon style={{ fontSize: 16 }} />{" "}
                  </button>
                  <button
                    className="btn_lang"
                    onClick={() => {
                      var x = document.createElement("STYLE");
                      var t = document.createTextNode("p {text-align: end;}");
                      x.appendChild(t);
                      document.head.appendChild(x);
                    }}
                  >
                    <FormatAlignRightIcon style={{ fontSize: 16 }} />
                  </button>
                </div>
              </div>

              <div className="location">
                {props.geofences.geo_name !== "null" &&
                props.geofences.geo_name !== null ? (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => {
                      if (props.geofences.geo_y < props.geofences.geo_x) {
                        window.open(
                          `https://maps.google.com/?q=${props.geofences.geo_y},${props.geofences.geo_x}`,
                          "_blank"
                        );
                      } else {
                        window.open(
                          `https://maps.google.com/?q=${props.geofences.geo_x},${props.geofences.geo_y}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    {" "}
                    <LocationOnIcon style={{ fontSize: 20 }} />{" "}
                    {props.geofences.geo_name}{" "}
                  </div>
                ) : null}
              </div>

              <div
                style={{
                  width: "100%",
                  paddingBottom: 35,
                  textAlign: "end",
                  fontSize: 16,
                  paddingTop: 10,
                  height: 150,
                  overflow: "auto",
                }}
              >
                {getExtraDescription()
                  .split("\n")
                  .map((i, n) => {
                    return <p key={n + "extra"}>{i}</p>;
                  })}
                {props && props.desc ? (
                  props.desc.split("\n").map((i, n) => {
                    return <p key={n}>{i}</p>;
                  })
                ) : (
                  <></>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row-reverse",
                    width: "85%",
                    flexWrap:'wrap',
                    gap:'5px',
                    backgroundColor:'#f3f3f3',
                    padding:'10px 10px',
                    borderRadius:'10px'
                  }}
                >
                  {[
                    APP_CONSTANTS.INSTALLATION_TYPE,
                    APP_CONSTANTS.CUSTOMER_CARE_TYPE,
                  ].includes(props.task_type_id) ? (
                    <></>
                  ) : (
                    <>
                      {/* <AssingUser users={props.users} id={props.id} onRefTask={props} assigned={props.assigned} /> */}
                      <Tooltip title={<span>Assignd users</span>} arrow>
                        <IconButton
                          onClick={() => setShowAssing(true)}
                          sx={{
                            marginRight: "5px",
                            backgroundColor: "#e1e1e1 !important",
                            "&:hover": {
                              backgroundColor: "#f1f1f1 !important",
                            },
                          }}
                        >
                          <GroupIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={<span>Edit</span>} arrow>
                        <IconButton
                          onClick={() => setShowEdit(true)}
                          sx={{
                            backgroundColor: "#e1e1e1 !important",
                            marginRight: "5px",
                            "&:hover": {
                              backgroundColor: "#f1f1f1 !important",
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip title={<span>Attach File</span>} arrow>
                    <IconButton
                      onClick={() => setShowAttachFile(true)}
                      sx={{
                        backgroundColor: "#e1e1e1 !important",
                        marginRight: "5px",
                        "&:hover": {
                          backgroundColor: "#f1f1f1 !important",
                        },
                      }}
                    >
                      <AttachFileIcon />
                    </IconButton>
                  </Tooltip>
                  {props?.SubTaskId ? (
                    <div
                      style={{
                        backgroundColor: "lightgray",
                        width: "fit-content",
                        padding: "10px 10px",
                        height: "fit-content",
                        marginRight: "10px",
                        borderRadius: "5px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <span>
                        It's Associated to Task
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                            marginLeft: "10px",
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                            padding: "1px 10px",
                          }}
                          onClick={() =>
                            openAssociatedTask(
                              props?.SubTaskId,
                              props?.TaskId,
                              props?.externalTasks
                            )
                          }
                        >{`#${props?.SubTaskId}`}</span>
                      </span>
                      {subTaskData && subTaskData?.status ? (
                        <span style={{ marginTop: "12px" }}>
                          Task Associated Status{"  "}
                          <span
                            style={{
                              color: getStatusColor(subTaskData?.status),
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              padding: "1px 10px",
                              cursor: "pointer",
                              marginLeft: "2px",
                            }}
                            onClick={() =>
                              openAssociatedTask(
                                props?.SubTaskId,
                                props?.TaskId,
                                props?.externalTasks
                              )
                            }
                          >
                            {subTaskData?.status}
                          </span>
                        </span>
                      ) : null}

                      {/* <button></button> */}
                    </div>
                  ) : props?.task_type_id == 9 || props?.task_type_id == 15 ? (
                    <Tooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Create Installation Task{" "}
                          </Typography>
                        </React.Fragment>
                      }
                      arrow
                    >
                      <div
                        style={{
                          backgroundColor: "#fff",
                          width: "fit-content",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          height: "fit-content",
                          padding: "10px 15px ",
                          marginRight: "10px",
                          boxShadow: " 0px 0px 0px 3px #000000;",
                          boxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          WebkitBoxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          MozBoxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          getEditTaskDataFromAPI(props?.TaskId, true)
                        }
                      >
                        <AddIcon
                          style={{
                            color: "rgb(46 107 149)",
                            marginRight: "5px",
                          }}
                        />
                        <span>Add Installation</span>
                      </div>
                    </Tooltip>
                  ) : null}
                  {props?.is_mission_task == 1 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "0 10px",
                        backgroundColor: "#fff",
                        padding: "5px 15px 5px 5px",
                        borderRadius: "5px",
                        boxShadow: "0 0 10px -5px rgba(0,0,0,0.5)",
                        height: "45px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        getEditTaskDataFromForMissionAPI(props?.TaskId);
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          getEditTaskDataFromForMissionAPI(props?.TaskId);
                        }}
                      >
                        <AiIcons.AiOutlinePlus />
                      </IconButton>
                      <span>Create Mission</span>
                    </div>
                  ) : null}
                  <Tooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Show all related missions
                          </Typography>
                        </React.Fragment>
                      }
                      arrow
                    >
                      <div
                        style={{
                          backgroundColor: "#fff",
                          width: "fit-content",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          height: "fit-content",
                          padding: "10px 15px ",
                          marginRight: "10px",
                          boxShadow: " 0px 0px 0px 3px #000000;",
                          boxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          WebkitBoxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          MozBoxShadow: "0px 0px 10px -7px rgba(0,0,0,0.81)",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setShowAllMissions(true)
                        }
                      >
                        <RemoveRedEyeIcon
                          style={{
                            color: "rgb(46 107 149)",
                            marginRight: "5px",
                          }}
                        />
                        <span>Show Related Missions</span>
                      </div>
                    </Tooltip>
                </div>

                <Status
                  status={props.status}
                  onRefTask={props}
                  id={props.id}
                  SubTaskId={props?.SubTaskId}
                  externalTasks={props?.externalTasks}
                  TaskId={props?.TaskId}
                  setShowPromot={setShowPromot}
                  showPromot={showPromot}
                  subTaskData={subTaskData}
                  taskTypeId={props?.task_type_id}
                  getSubTaskData={getSubTaskData}
                />
              </div>
              
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  marginTop: "15px",
                }}
              >
                <span style={{ marginRight: 10 }}>
                  {props.status === "rejected" &&
                  JSON.parse(localStorage.getItem("roles")).includes(7) ? (
                    <i
                      className="far fa-trash-alt"
                      id="dels"
                      onClick={() => {
                        if (window.confirm("Delete the Task?")) {
                          Delete(props.id);
                        }
                      }}
                    ></i>
                  ) : null}
                </span>

                {JSON.parse(localStorage.getItem("roles")).includes(9) ===
                false ? null : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "help",
                      backgroundColor: "#d3d3d3",
                      borderRadius: "5px",
                      padding: "7px 22px",
                    }}
                    onClick={() => {
                      window.open(
                        feHost + `LogTable?id=${props.id}&name=${"Task"}`,
                        "_blank"
                      );
                    }}
                  >
                    <img
                      src={require("../../assets/img/log1.png")}
                      alt="img"
                      style={{ height: 20 }}
                      onClick={() => {
                        window.open(
                          feHost + `LogTable?id=${props.id}&name=${"Task"}`,
                          "_blank"
                        );
                      }}
                    />
                  </div>
                )}
                <div
                  style={{
                    width: "20%",
                    marginLeft: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#d3d3d3",
                    borderRadius: "5px",
                    padding: "1px 22px",
                  }}
                >
                  <Details id={props.id} onRefTask={props} />
                </div>
              </div>

              {props?.task_type_id === 15 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    margin: "15px 0 5px 0",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      {" "}
                      : نوع الطلب
                    </span>
                    <span style={{ margin: "0 5px", fontSize: "16px" }}>
                      {props?.request_type_name}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      {" "}
                      : موقع الطلب
                    </span>
                    <span style={{ margin: "0 5px", fontSize: "16px" }}>
                      {props?.request_location}{" "}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      : التاريخ المفضل للطلب{" "}
                    </span>
                    <span style={{ margin: "0 5px", fontSize: "16px" }}>
                      {handleGetDate(props?.prefered_date)
                        ? handleGetDate(props?.prefered_date)
                        : "لم يتم التعيين"}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      {" "}
                      : الوقت المفضل للطلب
                    </span>
                    <span style={{ margin: "0 5px", fontSize: "16px" }}>
                      {handleGetTime(props?.prefered_time, props?.prefered_date)
                        ? handleGetTime(
                            props?.prefered_time,
                            props?.prefered_date
                          )
                        : "لم يتم التعيين"}
                    </span>
                  </div>
                </div>
              ) : null}

              {props?.task_type_id === 15 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    margin: "0px 0",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      margin: "15px 0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        alignItems: "center",
                      }}
                    >
                      {renderRatingValue()}
                    </div>
                    <span
                      style={{
                        fontFamily: "Cairo",
                        fontSize: "20px",
                        marginLeft: "15px",
                      }}
                    >
                      تقييم الزبون
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      margin: "0 0 0 0",
                      position: "relative",
                      top: "-10px",
                    }}
                  >
                    <p
                      style={{
                        direction: "rtl",
                        textAlign: "justify",
                        wordBreak: "break-all",
                        whiteSpace: "break-spaces",
                      }}
                    >
                      {props?.rate_text}
                    </p>
                  </div>
                </div>
              ) : null}
              {props?.task_type_id === 15 &&
              props?.request_type?.mandatory_units == 1 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    margin: "15px 0",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Cairo",
                      fontSize: "17px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    className="UnitShow"
                    onClick={() => {
                      setIsShown(true);
                    }}
                  >
                    {`عرض تفاصيل الوحدات (عدد الوحدات ${props?.units?.length})`}
                  </span>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    margin: "15px 0",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Cairo",
                      fontSize: "17px",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    className="UnitShow"
                  >
                    لم يتم اختيار مركبات
                  </span>
                </div>
              )}
              {spin === true ? (
                <div style={{ width: "100%", position: "absolute" }}>
                  {/* <Lottie
                          options={{
                            animationData: loading
                          }}
                          width={300}
                          height={150}
                          position="absolute"
                        /> */}
                  <Preloading />
                </div>
              ) : null}
            </AccordionDetails>

            <div
              id="pan_main"
              style={{
                backgroundColor: "#DFE0E0",
              }}
            >
              <div style={{ width: "50%" }}>
                <Button
                  style={{ cursor: "default", color: "#000" }}
                  id="coment1"
                >
                  Comments {props.comments_count}
                </Button>
              </div>
              <div style={{ width: "50%" }}>
                <Button
                  style={{ cursor: "default", color: "#000" }}
                  id="coment1"
                >
                  WorkLog
                </Button>
              </div>
            </div>
            <div
              id="pan_main"
              style={{
                "align-items": "flex-start",
                backgroundColor: "#DFE0E0",
              }}
            >
              <div style={{ width: "50%" }}>
                <Comments
                  id={props.id}
                  onRefTask={props}
                  comment={props.comment}
                  comments_count={props.comments_count}
                />
              </div>
              <div style={{ width: "50%" }}>
                <WorkLogs
                  id={props.id}
                  onRefTask={props}
                  workLog={props.comment}
                  workLogs_count={props.comments_count}
                />
              </div>
            </div>
          </Accordion>
        </Box>
      </div>
    </div>
  );
}
